<template>
  <div id="app">
    <Navbar />

    <sidebar-menu
      v-show="!!user"
      :menu="menuItems"
      :collapsed="collapsed"
      :width="`${sidebar_width}px`"
      :width-collapsed="`${sidebar_width_collapsed}px`"
      theme="fantasy-theme"
      @toggle-collapse="onCollapse"
    />

    <div :style="{ 'padding-left': offset + 'px', 'margin-top': '44px' }">
      <section class="px-5 py-5">
        <router-view />
      </section>
    </div>

    <b-loading :active.sync="isEnableLoadingMask"></b-loading>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { TweenMax, Elastic } from 'gsap'
import Navbar from '@/components/layouts/Navbar'

export default {
  name: 'App',
  components: { Navbar },

  data() {
    return {
      collapsed: true,
      sidebar_width: 200,
      sidebar_width_collapsed: 50,
      offset_width: null,
      offset: 0
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('app', ['isEnableLoadingMask', 'menuItems'])
  },
  watch: {
    offset_width(newValue, oldValue) {
      const speed = newValue > oldValue ? 0.35 : 0.3
      TweenMax.to(this.$data, speed, { offset: newValue, ease: Elastic.line })
    },
    user(value) {
      if (value) {
        this.setMenuItems(value.permission_groups)
        this.updateOffsetWidth(this.collapsed)
      } else {
        this.offset_width = 0
      }
    }
  },
  mounted() {
    this.collapsed = this.isMobileDevice()
    if (this.user) {
      this.setMenuItems(this.user.permission_groups)
    }
  },
  updated() {
    if (this.user && this.offset_width == null) {
      this.updateOffsetWidth(this.collapsed)
    }
  },
  methods: {
    ...mapActions('app', ['setMenuItems']),
    onCollapse(collapsed) {
      this.collapsed = collapsed
      this.updateOffsetWidth(collapsed)
    },
    updateOffsetWidth(collapsed) {
      this.offset_width = collapsed
        ? this.sidebar_width_collapsed
        : this.sidebar_width
    }
  }
}
</script>
